import { Pipe, PipeTransform } from '@angular/core';
import { GeometricFormType } from 'src/app/geometrics-form/state/geometric-form.type';

@Pipe({
  name: 'layerName'
})
export class LayerNamePipe implements PipeTransform {

  transform(type: GeometricFormType, ...args: unknown[]): unknown {
    return NAMES[type];
  }

}

const NAMES = {
  'mitra-vertex': 'VERTEX',
  'mitra-edge': 'EGDE',
  'mitra-building': 'BUILDING'
};
